"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5262],{

/***/ 35262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BoardPagination_BoardPagination; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/ui/Icons/PaginationLeft2Icon.tsx


function PaginationLeft2Icon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.85355 4.64645C10.0488 4.84171 10.0488 5.15829 9.85355 5.35355L5.20711 10L9.85355 14.6464C10.0488 14.8417 10.0488 15.1583 9.85355 15.3536C9.65829 15.5488 9.34171 15.5488 9.14645 15.3536L4.14645 10.3536C3.95118 10.1583 3.95118 9.84171 4.14645 9.64645L9.14645 4.64645C9.34171 4.45118 9.65829 4.45118 9.85355 4.64645ZM15.8536 4.64645C16.0488 4.84171 16.0488 5.15829 15.8536 5.35355L11.2071 10L15.8536 14.6464C16.0488 14.8417 16.0488 15.1583 15.8536 15.3536C15.6583 15.5488 15.3417 15.5488 15.1464 15.3536L10.1464 10.3536C9.95118 10.1583 9.95118 9.84171 10.1464 9.64645L15.1464 4.64645C15.3417 4.45118 15.6583 4.45118 15.8536 4.64645Z",
            fill: "#121212"
        })
    });
}
/* harmony default export */ var Icons_PaginationLeft2Icon = (PaginationLeft2Icon);

;// CONCATENATED MODULE: ./src/ui/Icons/PaginationRight2Icon.tsx


function PaginationRight2Icon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.14645 4.64645C4.34171 4.45118 4.65829 4.45118 4.85355 4.64645L9.85355 9.64645C10.0488 9.84171 10.0488 10.1583 9.85355 10.3536L4.85355 15.3536C4.65829 15.5488 4.34171 15.5488 4.14645 15.3536C3.95118 15.1583 3.95118 14.8417 4.14645 14.6464L8.79289 10L4.14645 5.35355C3.95118 5.15829 3.95118 4.84171 4.14645 4.64645ZM10.1464 4.64645C10.3417 4.45118 10.6583 4.45118 10.8536 4.64645L15.8536 9.64645C16.0488 9.84171 16.0488 10.1583 15.8536 10.3536L10.8536 15.3536C10.6583 15.5488 10.3417 15.5488 10.1464 15.3536C9.95118 15.1583 9.95118 14.8417 10.1464 14.6464L14.7929 10L10.1464 5.35355C9.95118 5.15829 9.95118 4.84171 10.1464 4.64645Z",
            fill: "#121212"
        })
    });
}
/* harmony default export */ var Icons_PaginationRight2Icon = (PaginationRight2Icon);

;// CONCATENATED MODULE: ./src/ui/Icons/PaginationLeftIcon.tsx


function PaginationLeftIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.8536 4.64645C13.0488 4.84171 13.0488 5.15829 12.8536 5.35355L8.20711 10L12.8536 14.6464C13.0488 14.8417 13.0488 15.1583 12.8536 15.3536C12.6583 15.5488 12.3417 15.5488 12.1464 15.3536L7.14645 10.3536C6.95118 10.1583 6.95118 9.84171 7.14645 9.64645L12.1464 4.64645C12.3417 4.45118 12.6583 4.45118 12.8536 4.64645Z",
            fill: "#121212"
        })
    });
}
/* harmony default export */ var Icons_PaginationLeftIcon = (PaginationLeftIcon);

;// CONCATENATED MODULE: ./src/ui/Icons/PaginationRightIcon.tsx


function PaginationRightIcon(props) {
    var _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645L12.8536 9.64645C13.0488 9.84171 13.0488 10.1583 12.8536 10.3536L7.85355 15.3536C7.65829 15.5488 7.34171 15.5488 7.14645 15.3536C6.95118 15.1583 6.95118 14.8417 7.14645 14.6464L11.7929 10L7.14645 5.35355C6.95118 5.15829 6.95118 4.84171 7.14645 4.64645Z",
            fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : "#121212"
        })
    });
}
/* harmony default export */ var Icons_PaginationRightIcon = (PaginationRightIcon);

;// CONCATENATED MODULE: ./src/ui/BoardPagination/hooks/useBoardPagination.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

// pagination 생성기
// showPages: 보여질 페이지 수
// pages: 데이터들의 전체 페이지 수
// currentPage: 현재 페이지
var generatePagination = function(pages, currentPage, showPages) {
    return Array.from({
        length: pages >= showPages ? showPages : pages
    }, function(_, i) {
        if (currentPage <= 3 && pages <= showPages) {
            return i + 1;
        } else if (currentPage > 3 && pages > showPages) {
            if (currentPage <= pages - 2) {
                return currentPage - 2 + i;
            } else if (currentPage > pages - 2) {
                return pages - showPages + i + 1;
            }
        }
        return i + 1;
    });
};
var useBoardPagination = function(param) {
    var page = param.page, handlePage = param.handlePage, totalPages = param.totalPages, _showPages = param.showPages, showPages = _showPages === void 0 ? 5 : _showPages, _paginationType = param.paginationType, paginationType = _paginationType === void 0 ? "dynamic" : _paginationType, _value = param.value, value = _value === void 0 ? "" : _value, _isRouterUrlChange = param.isRouterUrlChange, isRouterUrlChange = _isRouterUrlChange === void 0 ? false : _isRouterUrlChange, routerUrl = param.routerUrl;
    var ref = (0,react.useState)([]), generateStaticPagination = ref[0], setGenerateStaticPagination = ref[1];
    var ref1 = (0,react.useState)(""), handleType = ref1[0], setHandleType = ref1[1];
    var generatedPagination = (0,react.useMemo)(function() {
        return paginationType === "static" ? generateStaticPagination : generatePagination(totalPages, page, showPages);
    }, [
        page,
        generateStaticPagination,
        totalPages,
        paginationType,
        showPages
    ]);
    var onClickPageNumber = function(_page) {
        handlePage && handlePage(_page);
        if (isRouterUrlChange && routerUrl && routerUrl !== "") {
            location.href = "".concat(routerUrl, "?page=").concat(_page);
        }
    };
    var handlePageRouter = function(type) {
        if (type === "first") {
            handlePage && handlePage(1);
            if (isRouterUrlChange && routerUrl && routerUrl !== "") {
                location.href = "".concat(routerUrl, "?page=", 1);
            }
            return;
        }
        if (type === "last") {
            handlePage && handlePage(totalPages);
            if (isRouterUrlChange && routerUrl && routerUrl !== "") {
                location.href = "".concat(routerUrl, "?page=").concat(totalPages);
            }
            return;
        }
        if (type === "next") {
            if (page !== totalPages) {
                handlePage && handlePage(page + 1);
                if (isRouterUrlChange && routerUrl && routerUrl !== "") {
                    location.href = "".concat(routerUrl, "?page=").concat(Number(page) + 1);
                }
            }
        } else if (type === "prev") {
            if (page !== 1) {
                handlePage && handlePage(page - 1);
                if (isRouterUrlChange && routerUrl && routerUrl !== "") {
                    location.href = "".concat(routerUrl, "?page=").concat(Number(page) - 1);
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        if (handleType === "prev") {
            if (page % 10 === 0) {
                var arr = Array.from({
                    length: showPages
                }, function(_, i) {
                    return page - i;
                });
                var result = _toConsumableArray(arr).reverse().filter(function(v) {
                    return v <= totalPages;
                });
                setGenerateStaticPagination(result);
            }
        } else if (handleType === "next") {
            if (page % 10 === 1) {
                var arr1 = Array.from({
                    length: showPages
                }, function(_, i) {
                    return page + i;
                });
                var result1 = arr1.filter(function(v) {
                    return v <= totalPages;
                });
                setGenerateStaticPagination(result1);
            }
        } else {
            var result2 = Array.from({
                length: showPages
            }, function(_, i) {
                return i + 1;
            }).filter(function(v) {
                return v <= totalPages;
            });
            setGenerateStaticPagination(result2);
        }
    }, [
        handleType,
        page,
        totalPages,
        showPages,
        setGenerateStaticPagination
    ]);
    return {
        setHandleType: setHandleType,
        generatedPagination: generatedPagination,
        onClickPageNumber: onClickPageNumber,
        handlePageRouter: handlePageRouter
    };
};
/* harmony default export */ var hooks_useBoardPagination = (useBoardPagination);

// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(19676);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
;// CONCATENATED MODULE: ./src/ui/BoardPagination/BoardPagination.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  color: black;\n  background-color: transparent;\n  cursor: ",
        ";\n  &:focus {\n    outline: none;\n    background-color: transparent;\n  }\n  &:active {\n    background-color: transparent;\n  }\n  &:hover {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: 2px;\n          left: 50%;\n          transform: translateX(-50%);\n          width: ",
        "px;\n          height: 1.4px;\n          background-color: ",
        ";\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 21px;\n  height: 20px;\n  ",
        ";\n  cursor: pointer;\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}










// pagination 생성기
// showPages: 보여질 페이지 수
// pages: 데이터들의 전체 페이지 수
// currentPage: 현재 페이지
var BoardPagination_generatePagination = function(pages, currentPage, showPages) {
    return Array.from({
        length: pages >= showPages ? showPages : pages
    }, function(_, i) {
        if (currentPage <= 3 && pages <= showPages) {
            return i + 1;
        } else if (currentPage > 3 && pages > showPages) {
            if (currentPage <= pages - 2) {
                return currentPage - 2 + i;
            } else if (currentPage > pages - 2) {
                return pages - showPages + i + 1;
            }
        }
        return i + 1;
    });
};
/**
 * @param page 현재 페이지
 * @param handlePage 페이지 핸들링 함수
 * @param totalPages 총 페이지 수
 * @param showPages
 * - 페이지네이션으로 보여질 페이지 버튼 개수
 * - 5 Or 10 으로 타입 설정.
 * - 5일 때 paginationType="dynamic"
 * - 10일 때 paginationType="static"
 * @param hasFirstArrow 처음으로 이동 버튼 여부(<<)
 * @param hasLastArrow 마지막으로 이동 버튼 여부(>>)
 * @param paginationType 페이지네이션 타입 설정(dynamic)
 * @param value 우편번호 검색 시 필요한 파라미터(주소 검색 값 변경 여부 체크)
 * @param isRouterUrlChange 페이지 클릭시 query-string 변경할건지 여부
 * - 초기값 false
 * @param routerUrl 페이지 클릭시 query-string에 표시되는 URL
 * ex) `/my/consult` / `/shop/search`
 * @param gtmName BoardPagination이 쓰이는 컴포넌트 페이지 이름입니다.(gtm을 위해 이 값을 넘깁니다.)
 * gtmName을 optional param으로 설정하였고, gtmName을 넘기지 않으면, 빈 문자열로 받아집니다.
 * ex) 'shop_search'
 */ function BoardPagination(param) {
    var page = param.page, handlePage = param.handlePage, totalPages = param.totalPages, _showPages = param.showPages, showPages = _showPages === void 0 ? 5 : _showPages, _hasFirstArrow = param.hasFirstArrow, hasFirstArrow = _hasFirstArrow === void 0 ? true : _hasFirstArrow, _hasLastArrow = param.hasLastArrow, hasLastArrow = _hasLastArrow === void 0 ? true : _hasLastArrow, _paginationType = param.paginationType, paginationType = _paginationType === void 0 ? "dynamic" : _paginationType, _value = param.value, value = _value === void 0 ? "" : _value, _isRouterUrlChange = param.isRouterUrlChange, isRouterUrlChange = _isRouterUrlChange === void 0 ? false : _isRouterUrlChange, routerUrl = param.routerUrl, _gtmName = param.gtmName, gtmName = _gtmName === void 0 ? "" : _gtmName;
    var ref = hooks_useBoardPagination({
        page: page,
        totalPages: totalPages,
        handlePage: handlePage,
        isRouterUrlChange: isRouterUrlChange,
        routerUrl: routerUrl,
        paginationType: paginationType,
        showPages: showPages,
        value: value
    }), generatedPagination = ref.generatedPagination, handlePageRouter = ref.handlePageRouter, onClickPageNumber = ref.onClickPageNumber, setHandleType = ref.setHandleType;
    /**
   * @description pagination GTM 객체 만드는 함수입니다.
   * @param type page, prev1, prev2, next1, next2
   * @example
   * ```
   * <tag
   *   ...
   *   {...getPaginationGtm('page')}
   * >
   *    ...
   * </tag>
   * ```
   */ var getPaginationGtm = (0,react.useCallback)(function(type) {
        var name = gtmName + "_pagination_";
        switch(type){
            case "next1":
                name += "next1_button";
                break;
            case "next2":
                name += "next2_button";
                break;
            case "prev1":
                name += "prev1_button";
                break;
            case "prev2":
                name += "prev2_button";
                break;
            default:
                name += "".concat(page, "_page_button");
        }
        return tracking/* default.tagGTM */.Z.tagGTM(name);
    }, [
        gtmName,
        page
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardPaginationWrap, _objectSpreadProps(_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM(gtmName)), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoardPaginationInner, {
            className: "board-pagination-inner",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationButtonGroup, {
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        hasFirstArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationIconWrap, _objectSpreadProps(_objectSpread({
                            onClick: function() {
                                return handlePageRouter("first");
                            },
                            isVisible: page === 1 || totalPages < 2 ? "hidden" : "visible"
                        }, getPaginationGtm("prev2")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PaginationLeft2Icon, {})
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationIconWrap, _objectSpreadProps(_objectSpread({
                            onClick: function() {
                                setHandleType("prev");
                                handlePageRouter("prev");
                            },
                            isVisible: page === 1 || totalPages < 2 ? "hidden" : "visible"
                        }, getPaginationGtm("prev1")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PaginationLeftIcon, {})
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationNumberList, {
                    className: "pagination-number-list",
                    children: generatedPagination.map(function(_page, index, arr) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNumber, _objectSpreadProps(_objectSpread({
                            onClick: function() {
                                onClickPageNumber(_page);
                            },
                            isActive: page === arr[index],
                            page: _page
                        }, getPaginationGtm("page")), {
                            children: _page
                        }), "pagination-page-item-".concat(index));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationButtonGroup, {
                    style: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationIconWrap, _objectSpreadProps(_objectSpread({
                            onClick: function() {
                                setHandleType("next");
                                handlePageRouter("next");
                            },
                            isVisible: totalPages <= 5 || page === totalPages ? "hidden" : "visible"
                        }, getPaginationGtm("next1")), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PaginationRightIcon, {})
                        })),
                        hasLastArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationIconWrap, _objectSpreadProps(_objectSpread({
                            onClick: function() {
                                return handlePageRouter("last");
                            }
                        }, getPaginationGtm("next2")), {
                            isVisible: totalPages <= 5 || page === totalPages ? "hidden" : "visible",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_PaginationRight2Icon, {})
                        }))
                    ]
                })
            ]
        })
    }));
}
/* harmony default export */ var BoardPagination_BoardPagination = (BoardPagination);
var BoardPaginationWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BoardPagination__BoardPaginationWrap",
    componentId: "sc-67e47ab4-0"
})(_templateObject());
var BoardPaginationInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BoardPagination__BoardPaginationInner",
    componentId: "sc-67e47ab4-1"
})(_templateObject1());
var PaginationButtonGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BoardPagination__PaginationButtonGroup",
    componentId: "sc-67e47ab4-2"
})(_templateObject2());
var PaginationIconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BoardPagination__PaginationIconWrap",
    componentId: "sc-67e47ab4-3"
})(_templateObject3(), function(param) {
    var isActive = param.isActive;
    return isActive ? "default" : "pointer";
});
var PaginationNumberList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "BoardPagination__PaginationNumberList",
    componentId: "sc-67e47ab4-4"
})(_templateObject4());
var PageNumber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BoardPagination__PageNumber",
    componentId: "sc-67e47ab4-5"
})(_templateObject6(), function(param) {
    var isActive = param.isActive;
    return isActive ? styles/* theme.typography.button.md_b */.rS.typography.button.md_b : styles/* theme.typography.button.md_r */.rS.typography.button.md_r;
}, function(param) {
    var isActive = param.isActive, page = param.page;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), String(page).length * 9, styles/* theme.colors.neutral_colors.primary */.rS.colors.neutral_colors.primary);
});

;// CONCATENATED MODULE: ./src/ui/BoardPagination/index.ts



/***/ })

}]);